import React from 'react';

const ModeHelpTooltip = ({ onClose }) => {
  return (
    <div className="mode-help-overlay">
      <div className="mode-help-content">
        <h4>Auto Find Path Mode Help</h4>
        <button className="close-button" onClick={onClose}>×</button>
        <div className="help-text">
          <p><strong>Purpose:</strong> Automatically calculate optimal multi-modal transport routes using advanced algorithms. The system will find the best path considering connections, transport modes, and constraints.</p>
          
          <p><strong>Prerequisites:</strong></p>
          <ul>
            <li>Location points set up in Setup Mode</li>
            <li>Start and end points defined</li>
            <li>Connections created in Connection Mode</li>
          </ul>

          <p><strong>Operation Steps:</strong></p>
          <ol>
            <li><strong>Review Configuration:</strong>
              <ul>
                <li>Verify location points are displayed</li>
                <li>Check start and end points are set correctly</li>
              </ul>
            </li>
            <li><strong>Select Algorithm:</strong>
              <ul>
                <li><strong>Standard Mode (Demand = 0):</strong>
                  <ul>
                    <li>Connection Shortest Path - Finds fastest route using predefined connections</li>
                    <li>Multi-mode Shortest Path - Optimizes across different transport modes</li>
                  </ul>
                </li>
                <li><strong>Capacity Constraint Mode (Demand &gt; 0):</strong>
                  <ul>
                    <li>Capacity Constrained Shortest Path - Considers vehicle capacity limits</li>
                    <li>Calculates required trips based on demand/capacity ratio</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li><strong>Click "Auto Solve":</strong>
              <ul>
                <li>System calculates optimal route</li>
                <li>Results display on map with color-coded paths</li>
              </ul>
            </li>
            <li><strong>Review Results:</strong>
              <ul>
                <li>View total travel duration</li>
                <li>Check route sequence</li>
                <li>In capacity mode: see trips needed and total time</li>
              </ul>
            </li>
          </ol>

          <p><strong>Result Information:</strong></p>
          <ul>
            <li><strong>Path Sequence:</strong> Order of locations visited</li>
            <li><strong>Total Duration:</strong> Total travel time in hours</li>
            <li><strong>Capacity Analysis:</strong> (If demand &gt; 0)
              <ul>
                <li>Single Trip Time per segment</li>
                <li>Trips Needed per segment</li>
                <li>Segment Total Time (duration × trips)</li>
              </ul>
            </li>
          </ul>

          <p><strong>Tips:</strong></p>
          <ul>
            <li>Different algorithms may produce different results</li>
            <li>Try multiple algorithms and compare in Comparison Mode</li>
            <li>Ensure all necessary connections exist before solving</li>
            <li>Capacity constraints significantly affect routing decisions</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModeHelpTooltip; 